export enum enumDLIDocFunction {
  'Standard' = 1,
  'RelIssue',
  'CellBank Activation',
  'Change Classification',
  'One Page Format',
  'Furneral Policy',
  'Funeral Certification',
}

export namespace enumDLIDocFunction {
  export function values() {
    return Object.keys(enumDLIDocFunction).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
